module.exports = __webpack_public_path__ + "fonts/SourceHanSans-Bold.da59df9.woff2";